import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { CheckCircle2 } from 'lucide-react';
import LandingNav from '../components/landing/LandingNav';
import FooterSection from '../components/landing/FooterSection';
import SMBBetaHero from './smb-beta-landing/SMBBetaHero';
import SMBBetaBenefits from './smb-beta-landing/SMBBetaBenefits';
import SMBBetaForm from './smb-beta-landing/SMBBetaForm';

const SMBBetaLanding = () => {
  const { t } = useTranslation();
  const [submitted, setSubmitted] = useState(false);

  if (submitted) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
        <Helmet>
          <title>{t('smb.meta.titleSuccess')}</title>
          <meta name="robots" content="noindex" />
        </Helmet>
        <LandingNav />
        <div className="pt-32 pb-20 px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl mx-auto text-center">
            <div className="mb-6">
              <CheckCircle2 className="w-16 h-16 text-primary mx-auto" />
            </div>
            <h1 className="text-4xl font-bold text-slate-900 mb-4">
              {t('smb.success.title')}
            </h1>
            <p className="text-xl text-slate-600 mb-8">
              {t('smb.success.description')}
            </p>
            <div className="bg-secondary/30 border border-primary/20 rounded-lg p-6">
              <p className="text-slate-700">
                {t('smb.success.nextSteps')}
              </p>
            </div>
          </div>
        </div>
        <FooterSection />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
      <Helmet>
        <title>{t('smb.meta.title')}</title>
        <meta name="description" content={t('smb.meta.description')} />
        <meta name="robots" content="noindex" />
      </Helmet>

      <LandingNav />

      <SMBBetaHero />
      <SMBBetaBenefits />
      <SMBBetaForm onSuccess={() => setSubmitted(true)} />

      <FooterSection />
    </div>
  );
};

export default SMBBetaLanding;
